module.exports = __webpack_public_path__ + "pattern7.86f4c2397325bcd6305c.png";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/src/assets/images/pattern7.png
// module id = ../../../../../src/assets/images/pattern7.png
// module chunks = styles